import { OrderingController } from './lib';

function install(Vue, { name = OrderingController.name } = {}) {
  Vue.component(name, OrderingController);
}

export default { install };
export * from './lib';
